/*
 *  Draw Me A Kanji - v0.3.1
 *  A funny drawer for your Japanese writings
 *  http://drawmeakanji.com
 *
 *  Made by Matthieu Bilbille
 *  Under MIT License
 */
!(function () {
  'use strict'
  function a(a, b) {
    var c,
      d,
      e,
      f,
      g = []
    for (e = 0; e < a.length; e++)
      for (f = 0; f < a[e].length; f++)
        (d = Raphael.getTotalLength(a[e][f].path)),
          (c = {
            char: e,
            length: d,
            duration: d * b.step * 1e3,
            path: a[e][f].path,
            groups: a[e][f].groups,
            text: a[e][f].text,
            object: { path: null, text: null },
          }),
          g.push(c)
    return g
  }
  function b(a, b) {
    var c,
      d,
      e = []
    for (d = 0; a > d; d++)
      (c = new Raphael(b.element, b.width + 'px', b.height + 'px')),
        c.setViewBox(b.viewBox.x, b.viewBox.y, b.viewBox.w, b.viewBox.h),
        c.canvas.setAttribute('class', 'dmak-svg'),
        e.push(c)
    return e.reverse()
  }
  function c(a, b) {
    var c
    for (c = 0; c < a.length; c++)
      a[c].path('M' + b.viewBox.w / 2 + ',0 L' + b.viewBox.w / 2 + ',' + b.viewBox.h).attr(b.grid.attr),
        a[c].path('M0,' + b.viewBox.h / 2 + ' L' + b.viewBox.w + ',' + b.viewBox.h / 2).attr(b.grid.attr)
  }
  function d(a, b, c) {
    null !== a.object.text && a.object.text.remove()
    var d = function () {
      a.object.path.remove(), (a.object = { path: null, text: null }), b.shift()
    }
    c.stroke.animated.erasing ? ((a.object.path.node.style.stroke = c.stroke.attr.active), b.push(g(a, -1, c, d))) : d()
  }
  function e(a, b, c, d) {
    var e = function () {
      if (null !== b.object.path) {
        var a = d.stroke.attr.stroke
        'random' === d.stroke.attr.stroke && (a = Raphael.getColor()),
          (b.object.path.node.style.stroke = a),
          (b.object.path.node.style.transition = b.object.path.node.style.WebkitTransition = 'stroke 400ms ease'),
          c.shift()
      }
    }
    ;(b.object.path = a.path(b.path)),
      b.object.path.attr(d.stroke.attr),
      d.stroke.order.visible && f(a, b, d),
      d.stroke.animated.drawing ? g(b, 1, d, e) : e()
  }
  function f(a, b, c) {
    ;(b.object.text = a.text(b.text.x, b.text.y, b.text.value)), b.object.text.attr(c.stroke.order.attr)
  }
  function g(a, b, c, d) {
    return (
      a.object.path.attr({ stroke: c.stroke.attr.active }),
      (a.object.path.node.style.transition = a.object.path.node.style.WebkitTransition = 'none'),
      (a.object.path.node.style.strokeDasharray = a.length + ' ' + a.length),
      (a.object.path.node.style.strokeDashoffset = b > 0 ? a.length : 0),
      a.object.path.node.getBoundingClientRect(),
      (a.object.path.node.style.transition = a.object.path.node.style.WebkitTransition =
        'stroke-dashoffset ' + a.duration + 'ms ease'),
      (a.object.path.node.style.strokeDashoffset = b > 0 ? '0' : a.length),
      setTimeout(d, a.duration)
    )
  }
  function h(a) {
    if (null === a || 'object' != typeof a) return a
    var b = a.constructor()
    for (var c in a) b[c] = h(a[c])
    return b
  }
  function i(a, b) {
    if (2 !== arguments.length) throw new Error('Missing arguments in assign function')
    for (var c in a) b.hasOwnProperty(c) && (a[c] = 'object' == typeof b[c] ? i(a[c], b[c]) : b[c])
    return a
  }
  var j = function (a, b) {
    if (
      ((this.text = a),
      (this.options = i(h(j['default']), b)),
      (this.strokes = []),
      (this.papers = []),
      (this.pointer = 0),
      (this.timeouts = { play: [], erasing: [], drawing: [] }),
      !this.options.skipLoad)
    ) {
      var c = new DmakLoader(this.options.uri),
        d = this
      c.load(a, function (a) {
        d.prepare(a), d.options.loaded(d.strokes), d.options.autoplay && d.render()
      })
    }
  }
  ;(j.VERSION = '0.2.0'),
    (j['default'] = {
      uri: '',
      skipLoad: !1,
      autoplay: !0,
      height: 109,
      width: 109,
      viewBox: { x: 0, y: 0, w: 109, h: 109 },
      step: 0.03,
      element: 'draw',
      stroke: {
        animated: { drawing: !0, erasing: !0 },
        order: { visible: !1, attr: { 'font-size': '8', fill: '#999999' } },
        attr: {
          active: '#BF0000',
          stroke: '#2C2C2C',
          'stroke-width': 4,
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
        },
      },
      grid: { show: !0, attr: { stroke: '#CCCCCC', 'stroke-width': 0.5, 'stroke-dasharray': '--' } },
      loaded: function () {},
      erased: function () {},
      drew: function () {},
    }),
    (j.fn = j.prototype =
      {
        prepare: function (d) {
          ;(this.strokes = a(d, this.options)),
            (this.papers = b(d.length, this.options)),
            this.options.grid.show && c(this.papers, this.options)
        },
        erase: function (a) {
          if (this.timeouts.play.length) return !1
          if (this.pointer <= 0) return !1
          'undefined' == typeof a && (a = 0)
          do
            this.pointer--,
              d(this.strokes[this.pointer], this.timeouts.erasing, this.options),
              this.options.erased(this.pointer)
          while (this.pointer > a)
        },
        render: function (a) {
          if (this.timeouts.play.length) return !1
          if ('undefined' == typeof a) a = this.strokes.length
          else if (a > this.strokes.length) return !1
          var b,
            c = function (a) {
              e(a.papers[a.strokes[a.pointer]['char']], a.strokes[a.pointer], a.timeouts.drawing, a.options),
                a.options.drew(a.pointer),
                a.pointer++,
                a.timeouts.play.shift()
            },
            d = 0
          for (b = 0; b < this.timeouts.erasing.length; b++)
            window.clearTimeout(this.timeouts.erasing[b]), (this.timeouts.erasing = [])
          for (b = this.pointer; a > b; b++)
            !this.options.stroke.animated.drawing || 0 >= d ? c(this) : this.timeouts.play.push(setTimeout(c, d, this)),
              (d += this.strokes[b].duration)
        },
        pause: function () {
          for (var a = 0; a < this.timeouts.play.length; a++) window.clearTimeout(this.timeouts.play[a])
          this.timeouts.play = []
        },
        eraseLastStrokes: function (a) {
          this.erase(this.pointer - a)
        },
        renderNextStrokes: function (a) {
          this.render(this.pointer + a)
        },
      }),
    (window.Dmak = j)
})(),
  (function () {
    'use strict'
    function a(a, c, d, e) {
      var f = new XMLHttpRequest(),
        g = ('00000' + d).slice(-5)
      return '00020' === g || '03000' === g
        ? void e.done(c, { paths: [], texts: [] })
        : (f.open('GET', a + g + '.svg', !0),
          (f.onreadystatechange = function () {
            4 === f.readyState && (200 === f.status ? e.done(c, b(f.response, g)) : e.error(f.statusText))
          }),
          void f.send())
    }
    function b(a, b) {
      function c(a) {
        var b,
          d = a.childNodes
        for (b = 0; b < d.length; b++)
          'g' === d[b].tagName
            ? (h.push(d[b].getAttribute('id')), c(d[b]), h.splice(h.indexOf(d[b].getAttribute('id')), 1))
            : 'path' === d[b].tagName && e.push({ path: d[b].getAttribute('d'), groups: h.slice(0) })
      }
      var d,
        e = [],
        f = new DOMParser().parseFromString(a, 'application/xml'),
        g = f.querySelectorAll('text'),
        h = []
      for (c(f.getElementById('kvg:' + b)), d = 0; d < g.length; d++)
        e[d].text = {
          value: g[d].textContent,
          x: g[d].getAttribute('transform').split(' ')[4],
          y: g[d].getAttribute('transform').split(' ')[5].replace(')', ''),
        }
      return e
    }
    var c = function (a) {
      this.uri = a
    }
    ;(c.prototype.load = function (b, c) {
      var d,
        e = [],
        f = b.length,
        g = 0,
        h = {
          done: function (a, b) {
            ;(e[a] = b), g++, g === f && c(e)
          },
          error: function (a) {
            console.log('Error', a)
          },
        }
      for (d = 0; f > d; d++) a(this.uri, d, b.charCodeAt(d).toString(16), h)
    }),
      (window.DmakLoader = c)
  })()
